import instance from 'utils/axios/instance.axios';
import { ORGANIZATIONS } from './_constant';

export const getAll = () => instance.get(ORGANIZATIONS.GET_ALL);

export const getById = (id = '') => instance.get(ORGANIZATIONS.GET_BY_ID(id));
